<template>
  <div>
    <h3>미션달성형 > {{isEdit?'수정':'등록'}}</h3>
    <b-card :header="'캠페인 '+(isEdit?'수정하기':'등록하기')">
      <span v-if="!adAccount"><h5 class="text-danger">광고계정을 먼저 선택해주세요</h5></span>
      <div v-else>
        <div>
          <a href="https://kakaogames.agit.in/g/300018382/wall" target="_blank">광고부킹 아지트</a>
          에 브랜드 이모티콘 지원 요청 및 완료 후 등록해주세요.<br>
          모든 항목에 값이 설정되어야 등록이 가능합니다.
        </div>
        <b-form class="mt-3"
                @submit.prevent="onSubmit">
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="광고주명">
            <b-form-input v-model="mission.advertiserName" disabled>

            </b-form-input>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="게임명"
                        :state="checkGameNameValid"
                        invalid-feedback="게임을 선택하세요">
            <b-form-select v-model="appId" :options="gameList"
                           text-field="name" value-field="id"
                           :state="checkGameNameValid"
                           :disabled="isEdit" @input="gameChanged">
              <template slot="first">
                <option :value="null" disabled>게임을 선택하세요</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="캠페인명"
                        :state="checkCampaignNameValid"
                        description="* 마이다스 어드민에 등록된 캠페인명으로 기재해 주세요.">
            <b-form-input v-model="mission.name"
                          :state="checkCampaignNameValid">

            </b-form-input>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="코드 이름"
                        :state="checkCodeNameValid"
                        invalid-feedback="코드 중복 체크를 해주세요"
                        description="* 게임에서 이모티콘 지급 요청 URL 호출 시 포함되는 code-name 입니다. URL 포맷 : https://game.kakao.com/code-names/{code-name}/users/{user-id}
                        <br>* 영소문자, 숫자만 입력해주세요.
                        <br><span style='color:red;'>* 캠페인 등록이 완료되면 코드 이름은 변경이 불가합니다. 변경이 필요하면 삭제 후 다시 등록해 주세요.</span>
                        ">
            <b-input-group>
              <b-form-input v-model="mission.codeName"
                            :state="checkCodeNameValid"
                            @change="isCodeNameValid = false"
                            :disabled="isEdit">

              </b-form-input>
              <b-input-group-append>
                <b-button @click="checkCodeName" :disabled="mission.codeName===originalCodeName">
                  중복체크
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="집행기간"
                        description="* 마이다스 어드민에 등록된 집행기간과 동일하게 설정해 주세요. API 연동테스트는 시작일 기준 30일 전부터 가능합니다."
                        :state="checkStartAtValid && checkEndAtValid"
                        :invalid-feedback="'집행 기간을 확인하세요.' + (!isStartAtBeforeThanEndAt?' 시작일은 종료일 이전으로 설정되어야 합니다.':'')">
            <b-row>
              <b-col>
                <date-picker v-model="mission.startAt" :config="dateOptions"
                             class="border-success"
                             :class="{'border-danger':!checkStartAtValid}"
                             :disabled="isOngoing">

                </date-picker>
              </b-col>
              <b-col class="col-auto col-form-label">~</b-col>
              <b-col>
                <date-picker v-model="mission.endAt" :config="dateOptions"
                             class="border-success"
                             :class="{'border-danger':!checkEndAtValid}">

                </date-picker>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="이모티콘 api key"
                        description="* 브랜드 이모티콘 지원 요청이 완료되면, 카카오에서 발급해주는 키값입니다."
                        :state="checkRewardApiKeyValid"
                        invalid-feedback="이모티콘 Api Key의 유효성 체크를 해주세요">
            <b-input-group>
              <b-form-input v-model="mission.extraInfo.kakaoRewardApiKey"
                            :state="checkRewardApiKeyValid"
                            @change="isRewardApiKeyValid=false"
                            :disabled="isOngoing">

              </b-form-input>
              <b-input-group-append>
                <b-button @click="checkEmoticonKey"
                          :disabled="isOngoing">
                  유효성 체크
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="총 구매금액"
                        description="* 마이다스 어드민에 등록된 금액으로 설정해 주세요.">
            <money class="form-control"
                   v-model="mission.totalPurchaseAmount"
                   v-bind="won">
            </money>
          </b-form-group>

          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="이모티콘 단가"
                        description="* 마이다스 어드민에 등록된 금액으로 설정해 주세요.">
            <money class="form-control"
                   v-model="mission.rewardUnitPrice"
                   v-bind="won">
            </money>
          </b-form-group>

          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="고객센터 문구"
                        :state="checkCustomerNameValid"
                        description="* 이모티콘 지급 요청 페이지의 주의사항에 노출되는 게임사의 고객센터 정보입니다.">
            <b-form-input v-model="mission.customerSupportName"
                          :state="checkCustomerNameValid">

            </b-form-input>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="고객센터 링크"
                        description="* 게임사 고객센터로 접속할 수 있는 링크가 있는 경우에만 설정하세요.<br>
                                     * 이메일 주소로 링크를 설정하는 경우에는 mailto:이메일주소 포맷으로 설정해주세요.">
            <b-form-input v-model="mission.customerSupportUrl">

            </b-form-input>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="아지트 링크"
                        :state="checkAgitUrlValid"
                        description="* 브랜드 이모티콘 지원 요청한 아지트 링크를 기재해 주세요.">
            <b-form-input v-model="mission.agitUrl"
                          :state="checkAgitUrlValid">

            </b-form-input>
          </b-form-group>
          <b-form-group label-cols="1" horizontal label-class="text-right"
                        label="미션 정의"
                        :state="checkMissionDescriptionValid"
                        description="* 게임에 적용된 이모티콘 지급 조건을 기재해 주세요.">
            <b-form-input v-model="mission.missionDescription"
                          :state="checkMissionDescriptionValid">

            </b-form-input>
          </b-form-group>
          <div class="text-center">
            <b-button class="mr-3" @click="toList">
              뒤로가기
            </b-button>
            <b-button type="submit" variant="primary">
              {{isNew?"등록하기":"수정완료"}}
            </b-button>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>

<script>
  import DatePicker from "vue-bootstrap-datetimepicker/src/component";
  import missionApi from "@/common/gap/api/missionApi.js";
  import adMasterApi from "@/common/gap/api/adMasterApi.js";
  import pregService from "@/common/api/preg.service.js";

  import playGameService from "@/common/api/playGame.service.js";
  import gapmoment from "@/common/gap/util/gapmoment";
  import {checkValidation} from "@/common/gap/util/validation";
  import Mission, {MISSION_ONGOING} from "@/common/gap/model/mission";

  import {Money} from "v-money";

  export default {
    components: {DatePicker, Money},
    props: {
      adAccount: null
    },
    data() {
      return {
        won: {precision: 0, suffix: ' 원'},
        dateOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: true
        },
        advertiser: null,
        gameList: [],
        appId: null,
        mission: new Mission(),

        originalCodeName: "",

        isCodeNameValid: false,
        isRewardApiKeyValid: false,
        isKakaoChannelIdValid: false,
      }
    },
    async mounted() {
      if (this.isNew) {
        this.refreshAdvertiser();
      }
      if (this.isEdit) {
        missionApi.getMission(this.editingMissionId).then(
            response => { //캠페인 찾아서 넣기
              if (response.data &&
                  response.data.data &&
                  response.data.data.mission) {
                this.mission = new Mission(response.data.data.mission);

                if (this.mission.isEnded()) {
                  alert("이미 끝난 미션은 수정할 수 없습니다.");
                  this.toList();
                  return;
                }

                //수정일때는 유효성 체크 버튼의 검증을 처음에 안해도 된다
                this.isCodeNameValid = true;
                this.isRewardApiKeyValid = true;
                this.isKakaoChannelIdValid = true;
                this.originalCodeName = this.mission.codeName;

                this.refreshAdvertiser();
              } else {
                alert(`잘못된 조회입니다. mission id : ${this.editingMissionId}`);
                this.toList();
              }
            }
        );
      }
    },
    methods: {
      refreshAdvertiser() {
        if (!this.adAccount) {
          return;
        }
        adMasterApi.getAdvertiser(this.adAccount.advertiserCorporateRegistrationNumber).then(
            response => {
              this.advertiser = response.data.data;
              this.mission.advertiserName = this.advertiser.name;
              adMasterApi.getApps(this.adAccount.advertiserCorporateRegistrationNumber).then(
                  response => {
                    this.gameList = response.data.data;
                    if (this.isEdit) {
                      console.log(this.mission);
                      adMasterApi.getCampaign(this.mission.campaignId, this.mission.adAccountId).then(
                          response => {
                            this.gameChanged(response.data.data.appId);
                          }
                      );
                    }
                  }
              );
            }
        );
      },
      gameChanged(appId) {
        this.appId = appId;
        this.mission.gameName = this.gameList.find(elm => elm.id === appId).name;
      },
      checkCodeName() {
        missionApi.checkCodeName(this.mission.codeName).then(
            response => {
              if (response.data.status === 200) {
                this.isCodeNameValid = true;
              } else if (response.data.status === 400 &&
                         response.data.error.code === "DUPLICATED_CODENAME") {
                alert("이미 있는 코드이름입니다.");
              }
            },
            error => {
              if (error.response.data.status === 404) {
                alert("잘못된 코드이름입니다.(영소문자, 숫자만 입력)");
              }
            }
        );
      },
      checkEmoticonKey() {
        pregService.chkEmoticonValidation(this.mission.extraInfo.kakaoRewardApiKey).then(
            response => {
              if (response.data &&
                  response.data.detail_code === "100") {
                this.isRewardApiKeyValid = true;
              } else {
                alert("올바르지 않은 이모티콘 키입니다.");
              }
            }
        )
      },
      async onSubmit() {
        let result = false;
        if (!this.adAccount) {
          alert("등록 전에 반드시 광고계정을 선택해주세요.");
          return;
        }
        if (!checkValidation(this)) {
          alert("입력값을 확인하세요");
          return;
        }

        const missionDto = this.mission.convertToDto();

        // API 보내기 전 작업
        if (this.isNew) {

          const createCampaignRequestBody = {
            adAccountId: this.adAccount.id,
            appId: this.appId,
            name: this.mission.name
          };

          const response = await adMasterApi.postCampaign(createCampaignRequestBody);
          missionDto.campaignId = response.data.data.campaign.id;
        }

        if (this.isNew) {
          // Ad Account Id 보내주기
          missionDto.adAccountId = this.adAccount.id;
          const data = await missionApi.postMission(missionDto);
          if (data.status === 200) {
            result = true;
          }
        } else {
          const data = await missionApi.updateMission(missionDto);
          if (data.status === 200) {
            result = true;
          }
        }
        if (result === true) {
          this.toList();
        } else {

          alert("서버에 문제가 있습니다. 관리자에게 문의해주세요");
          this.toList();
        }
      },
      toList() {
        this.$router.push({name: 'MissionsList'});
      }
    },
    computed: {
      editingMissionId() {
        return this.$route.params.missionId;
      },
      isEdit() {
        return !!this.editingMissionId;
      },
      isNew() {
        return !this.editingMissionId;
      },
      checkGameNameValid() {
        return !!this.mission.gameName;
      },
      checkCampaignNameValid() {
        return !!this.mission.name;
      },
      checkCodeNameValid() {
        return (this.originalCodeName && this.mission.codeName === this.originalCodeName) || this.isCodeNameValid;
      },

      isStartAtBeforeThanEndAt() {
        const startAtDate = new Date(this.mission.startAt).valueOf();
        const endAtDate = new Date(this.mission.endAt).valueOf();
        return startAtDate < endAtDate;
      },
      isOngoing() {
        return (this.isEdit && this.mission.isOnGoing());
      },
      checkStartAtValid() {
        return this.isStartAtBeforeThanEndAt && !!this.mission.startAt;
      },
      checkEndAtValid() {
        return this.isStartAtBeforeThanEndAt && !!this.mission.endAt;
      },

      checkRewardApiKeyValid() {
        return this.isRewardApiKeyValid;
      },
      checkCustomerNameValid() {
        return !!this.mission.customerSupportName;
      },
      checkAgitUrlValid() {
        return !!this.mission.agitUrl;
      },
      checkMissionDescriptionValid() {
        return !!this.mission.missionDescription;
      },
    },
    watch: {
      adAccount: {
        handler(newVal, oldVal) {
          if (newVal) {
            this.refreshAdvertiser();
          }
        },
        deep: true
      }
    }
  }
</script>

<style>

</style>

<!--

test data

valid 이모티콘 api key :  1ca95941a0c07b3da34e13d78417383d

-->
